<template>
  <el-container>

    <el-row :gutter="10">
      <el-col :span="24">
          <el-row :gutter="10">
            <el-col :span="16">
    
              <el-form :inline="true" :model="formInline" class="demo-form-inline" size="mini">
                <el-form-item>
                  <el-button type="primary" icon="el-icon-edit" @click="openDeviceForm(0)">新增</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="warning" icon="el-icon-upload2" @click="exportWin">导入</el-button>
                </el-form-item>
                <el-form-item>
                  <el-input v-model="selectedHoldName" placeholder="请选择" style="width:166px;"></el-input>
                  <el-button type="default" icon="el-icon-folder-opened" @click="openLayer">打开组织树</el-button>
                  <div v-if="isVisible" class="floating-layer">
                    <div class="layer-content">
                      <!-- 浮动层内容 -->
                      <div class="tree-divBox">
                        <el-tree 
                          :data="holdTreeData" 
                          :props="defaultProps" 
                          default-expand-all 
                          ref="getTreeInstance" 
                          @node-click="handleNodeClick"></el-tree>
                      </div>
                      <el-button type="info" size="mini" icon="el-icon-close" @click="closeLayer" circle></el-button>
                    </div>
                    <!-- <div class="overlay" @click="closeLayer"></div> -->
                  </div>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="formInline.search_type" placeholder="选择搜索类别" style="width:120px;">
                    <el-option
                      v-for="item in search_type_options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input v-model="formInline.key" placeholder="关键词"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="success" icon="el-icon-search" @click="SearchDeviceList()">查询</el-button>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="8">
              <el-form :inline="true" class="demo-form-inline" size="mini" style="text-align: right;">
                
              </el-form>
            </el-col>
          </el-row>

          <el-dialog
            width="600px"
            title="导入设备"
            :visible.sync="importDialogVisible"
            :center="true">
            <el-tabs v-model="activeName" @tab-click="handlePaneClick">
              <el-tab-pane label="批量输入" name="first">
                <div style="height: 20px;"></div>
                <el-form ref="form" label-width="80px">
                  <el-form-item label="所属用户">
                    <el-input :disabled="true" v-model="selectedHoldName"></el-input>
                  </el-form-item>
                  <el-form-item label="SN列表">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 10, maxRows: 30}"
                      placeholder="输入SN列表，用逗号','或换行符隔开"
                      v-model="textareaSN">
                    </el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="success" @click="importDeviceSNList">保存</el-button>
                    <el-button @click="oncancelExportWin">关闭</el-button>
                  </el-form-item>
                  <el-form-item v-if="displayImportSNResult">

                    <el-descriptions class="margin-top" title="导入结果" :column="3" border>
                      <el-descriptions-item>
                        <template slot="label">
                          <i class="el-icon-success"></i>
                          成功数量
                        </template>
                        {{importSNSuccess}}
                      </el-descriptions-item>
                      <el-descriptions-item>
                        <template slot="label">
                          <i class="el-icon-error"></i>
                          失败SN
                        </template>
                        {{importSNFailList}}
                      </el-descriptions-item>
                    </el-descriptions>

                  </el-form-item>
                </el-form>
              </el-tab-pane>
              <el-tab-pane label="导入文件" name="second">
                <div style="height: 20px;"></div>
                <el-form ref="form" label-width="80px">
                  <el-form-item label="所属用户">
                    <el-input :disabled="true" v-model="selectedHoldName"></el-input>
                  </el-form-item>
                  <el-form-item label="选择文件">
                    <el-upload
                      class="upload-demo"
                      action="/proxyserver/api/UploadFiles/action"
                      :limit="1"
                      :auto-upload="true"
                      :on-success="onUploadSuccess"
                      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel">
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" class="el-upload__tip">只能上传xlsx/xls文件，且不超过50M</div>
                      <div slot="tip" class="el-upload__tip">
                        <el-link href="https://www.gps881.com/proxyserver/api/deviceinfo/temp_device" type="warning" target="_blank">点击下载模板</el-link>
                      </div>
                    </el-upload>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="success" @click="onExportSubmit">导入</el-button>
                    <el-button @click="oncancelExportWin">关闭</el-button>
                  </el-form-item>
                  <el-form-item v-if="displayImportExcelResult">

                    <el-descriptions class="margin-top" title="导入结果" :column="3" border>
                      <el-descriptions-item>
                        <template slot="label">
                          <i class="el-icon-success"></i>
                          成功数量
                        </template>
                        {{importSNSuccess2}}
                      </el-descriptions-item>
                      <el-descriptions-item>
                        <template slot="label">
                          <i class="el-icon-error"></i>
                          失败SN
                        </template>
                        {{importSNFailList2}}
                      </el-descriptions-item>
                    </el-descriptions>

                  </el-form-item>
                </el-form>
              </el-tab-pane>
            </el-tabs>
          </el-dialog>
          
          <div>
              <el-table
                id="tbGridView"
                ref="getTableInstance"
                :data="tableData"
                :height="tableViewHeight"
                v-loading="loadingTableData"
                size="small"
                stripe
                style="width: 100%">
                <el-table-column
                  prop="number"
                  label="序号"
                  width="50">
                </el-table-column>
                <el-table-column
                  prop="IMEI"
                  label="IMEI/SN"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="object_name"
                  label="姓名"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="hold_name"
                  label="所属用户"
                  width="200">
                </el-table-column>
                <el-table-column
                  prop="remark"
                  label="备注">
                </el-table-column>
                <el-table-column
                  prop="create_time"
                  label="录入时间"
                  width="200">
                </el-table-column>
                <el-table-column
                  prop="operator"
                  label="操作"
                  width="200">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      @click="openDeviceForm(scope.row.object_id)">编辑</el-button>
                    <el-button
                      size="mini"
                      type="danger"
                      @click="removeDevice(scope.row.object_id)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
          </div>

          <div class="dv-pagging-container">
            <el-pagination
              background
              layout="prev, pager, next"
              :page-size="pagging.pager_size"
              :pager-count="pagging.pager_count"
              :total="pagging.records_total"
              :current-page="pagging.current_page">
            </el-pagination>
          </div>
      </el-col>
    </el-row>

    <DeviceInfoForm ref="deviceInfoForm" @eventRefreshTableName="SearchDeviceList" />

  </el-container>
</template>

<script>
import Api from '../../api/index'
import DeviceInfoForm from './DeviceInfoFormView.vue'

export default {
  name: 'device_manage',
  components: {
    DeviceInfoForm
  },
  data() {
    return {
      isVisible: false, // 控制浮动层是否显示
      dialogFormVisible: false,
      importDialogVisible: false,
      currentTabsNodeName: "staff-department",
      activeName: "first",
      textareaSN: "",
      displayImportSNResult: false,
      importSNSuccess: 0,
      importSNFailList: "",
      uploadFilePath: "",
      displayImportExcelResult: false,
      importSNSuccess2: 0,
      importSNFailList2: "",
      formInline: {
        key: '',
        search_type: 'device_no',
      },
      search_type_options: [
          {
            value: 'device_no',
            label: '设备ID'
          },{
            value: 'object_name',
            label: '设备名称'
          },{
            value: 'imei',
            label: 'IMEI'
          },{
            value: 'sim',
            label: 'SIM卡号'
          },{
            value: 'iccid',
            label: 'ICCID号'
          }
      ],
      tableViewHeight: 600,
      loadingTableData: false,
      selectHoldId: 0,
      selectedHoldName: "",
      holdTreeData: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      tableData: [],
      pagging: {
        records_total: 0,
        pager_count: 5,
        pager_size: 25,
        current_page: 1
      }
    }
  },
  methods: {
    openLayer() {
      this.isVisible = true;
    },
    closeLayer() {
      this.isVisible = false;
    },
    /**
     * 将字符串以逗号或换行符分割成数组
     * @param {string} str - 要分割的字符串
     * @returns {Array} 分割后的数组
     */
    splitByCommaOrNewline: function(str) {
      // 使用正则表达式匹配逗号或换行符（包括Windows和Unix风格的换行符）
      return str.split(/[,|\r\n|\n|\r]+/)
        // 过滤掉空字符串
        .filter(item => item.trim() !== '');
    },
    loadHoldTree: function(){
      Api.GetHoldTree({}).then(res => {
        if(!res)
          return;
        this.holdTreeData = res.data;

        // 初始化选中的用户id
        this.selectHoldId = this.holdTreeData[0].id;
        this.selectedHoldName = this.holdTreeData[0].label;
      });
    },
    SearchDeviceList: function() {
      this.loadingTableData = true;
      var argdata = {
        search_type: this.formInline.search_type,
        key: this.formInline.key,
        ContainChildren: true,
        HoldID: this.selectHoldId,
        PageIndex: this.pagging.current_page,
        PageSize: this.pagging.pager_size
      };
      
      this.tableData = [];
      Api.SearchDeviceList(argdata).then(res => {
        this.loadingTableData = false;
        if(!res)
          return;
        if(res.code === 200 && res.data) {
          this.pagging.records_total = res.total;
          for(var i=0; i<res.data.length; i++) {
            this.tableData.push({
              number: (i + 1),
              object_id: res.data[i].object_id,
              object_name: res.data[i].object_name,
              IMEI: res.data[i].device_no,
              //SIM: res.data[i].sim,
              //status: res.data[i].status,
              hold_name: res.data[i].hold_name,
              remark: res.data[i].remark,
              create_time: res.data[i].create_time,
            });
          }
        } else {
          this.$message.error(err);
        }
      }).catch(err => {
        this.$message.error('错了哦，接口出错！' + err);
        this.loadingTableData = false;
      });
    },
    importDeviceSNList: function() {
      const list = this.splitByCommaOrNewline(this.textareaSN);

      if(list.length === 0) {
        this.$message.error('请输入SN列表');
        return;
      }

      var argdata = {
        HoldID: this.selectHoldId,
        SNList: list
      };

      console.log(argdata);
      Api.ImportDeviceBySNList(argdata).then(res => {
        if(!res) {
          this.$message.error('导入失败！');
          this.importSNSuccess = 0;
          this.importSNFailList = list.join(",");
          return;
        }
        if(res.code === 200 && res.data) {
          this.displayImportSNResult = true;
          this.importSNSuccess = res.data.effectCount;
          this.importSNFailList = res.data.failSNList.join(",");
          // 刷新列表
          this.SearchDeviceList();
        } else {
          this.$message.error('导入失败！');
          this.importSNSuccess = 0;
          this.importSNFailList = list.join(",");
        }
      });
    },
    handleNodeClick: function(data) {
      this.selectHoldId = data.id;
      this.selectedHoldName = data.label;
      this.closeLayer();
      this.SearchDeviceList();
    },
    openDeviceForm: function(id) {
      this.$refs.deviceInfoForm.show(id, this.selectHoldId);
    },
    removeDevice: function(id) {
      this.$confirm('此操作将删除该设备信息, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
         var argdata = {
            object_ids: [id]
          };
          Api.RemoveDevice(argdata).then(res => {
            if(res.code === 200) {
                  this.$message({
                      message: '已删除！',
                      type: 'success'
                  });
                  this.SearchDeviceList();
              } else {
                  this.$message({
                      message: '删除失败！',
                      type: 'warning'
                  });
              }
          });
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // });
      });
    },
    exportWin: function() {
      this.importDialogVisible = true;
    },
    onUploadSuccess: function(response, file, fileList) {
      if(response.errCode === 0) {
        this.uploadFilePath = response.result.imagePath;
        console.log(response.result.imagePath);
      } else {
        this.uploadFilePath = "";
      }
    },
    onExportSubmit: function() {
      if(!this.uploadFilePath) {
        this.$message.error('请先上传文件！');
        return;
      }
      var argdata = {
        HoldID: this.selectHoldId,
        FilePath: this.uploadFilePath
      };
      Api.ImportDeviceByExcel(argdata).then(res => {
        if(!res) {
          this.$message.error('导入失败！');
          this.importSNSuccess2 = 0;
          this.importSNFailList2 = "----";
          return;
        }
        if(res.code === 200 && res.data) {
          this.displayImportExcelResult = true;
          this.importSNSuccess2 = res.data.effectCount;
          this.importSNFailList2 = res.data.failList.join(",");
          // 刷新列表
          this.SearchDeviceList();
        } else {
          this.$message.error('导入失败！');
          this.importSNSuccess2 = 0;
          this.importSNFailList2 = list.join(",");
        }
      });
    },
    oncancelExportWin: function() {
      this.importDialogVisible = false;
    },
    handlePaneClick: function(tab) {

    }
  },
  mounted() {
    var h = document.body.clientHeight - 60 - 120;
    var h2 = document.body.clientHeight - 115;
    this.$nextTick(() => {
      const table = this.$refs.getTableInstance;
      if (table) {
        // 使用原生JavaScript设置高度
        table.$el.style.height = h + 'px';
        // 或者使用Vue.set来响应式地更新样式
        // this.$set(table.$el.style, 'height', '300px');
      }
      const tree = this.$refs.getTreeInstance;
      if(tree) {
        tree.$el.style.height = h2 + 'px';
      }
    });

    this.loadHoldTree();
    this.SearchDeviceList();
  }
}
</script>
<style>
.tree-divBox {
  padding-top: 10px;
  padding-left: 10px;
  width: 95%;
  min-height: 500px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}
</style>